import styled from 'styled-components'

export const StyledSaveContainer = styled.div`
    padding-top: 5px;
`;